<template>
  <BaseTemplate :currentUser="currentUser" :isTop="true" :isWhiteBackground="false">
    <div v-if="packList" class="top">
      <!-- <div class="top_message">友達紹介キャンペーンは<a href="/change-member">こちら</a></div> -->
      <!-- <div class="top_message"><a href="/transfer-point">ポイント移行はこちら</a></div>
      <div class="top_message"><a href="/exchange-card">引換所はこちら</a></div>
      <div class="top_message"><a href="/change-member">友達紹介コードはこちら</a></div> -->
      <TopIconArea></TopIconArea>
      <!-- <div class="sub_title">
        <span>24時間ずっと引けるオンラインガチャ</span>
        <div class="pc" @click="showTokkyo">特許<br>出願中</div>
        <div class="sp" @click="showTokkyo">特許<br>出願中</div>
      </div> -->
      <!-- <h2>ガチャ一覧</h2> -->
      <div class="screen_switching">
        <RoundButton class="detail_button" :class="{active: showScreen == 2}" @handleRoundBtnClick="handleShowScreen(2)">
          <div>遊び方</div>
          <div>How to play</div>
        </RoundButton>
        <RoundButton class="detail_button" :class="{active: showScreen == 1}" @handleRoundBtnClick="handleShowScreen(1)">
          <div>ガチャを回す</div>
        </RoundButton>
      </div>
      <div class="_pack_list" v-if="showScreen == 1">
        <div class="product-list" v-if="productList[0]">
          <ProductBanner v-for="(packItem) in productList[0]" :key="packItem.id" class="banner" :packItem="packItem"
            :currentUser="currentUser" @handleBannerClick="goToProductDetail" @handleLoginClick="goToLogin" />
        </div>
        <!-- <div class="sp list_button_area" v-if="productList[cardType.id]">
          <BlackGradationButton
            class="list_button"
            className="large"
            :text="t('一覧')"
            @handleSquareBtnClick="moveList(cardType.id)"
          />
        </div> -->
      </div>
      <div class="_pack_list how_to_play" v-if="showScreen == 2">
        <div class="how_to_play_title">
          <img src="/img/how_to_play_title.png" alt="ホッピーの遊び方">
        </div>
        <div class="how_to_play_content">
          <img src="/img/how_to_play_1.png" alt="遊び方1">
          <img src="/img/how_to_play_2.png" alt="遊び方2">
          <img src="/img/how_to_play_3.png" alt="遊び方3">
          <img src="/img/how_to_play_4.png" alt="遊び方4">
          <img src="/img/how_to_play_5.png" alt="遊び方5">
          <img src="/img/how_to_play_6.png" alt="遊び方6">
        </div>
      </div>
      <!-- <div class="double-flex">
        <ShadowButton
          class="shadow-button pc"
          text="特定商取引法に基づく表記"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button sp"
          text="特定商取引法"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button"
          text="利用規約"
          @handleShadowBtnClick="goToTermsOfService"
        />
        <ShadowButton
          class="shadow-button pc"
          text="個人情報保護ポリシー"
          @handleShadowBtnClick="goToPrivacyProtection"
        />
        <ShadowButton
          class="shadow-button sp"
          text="個人情報保護"
          @handleShadowBtnClick="goToPrivacyProtection"
        />
        <ShadowButton
          class="shadow-button"
          text="ご利用ガイド"
          @handleShadowBtnClick="goToUserGuide"
        />
      </div>
      <div class="footer">
        <div class="left">
          <img src="/img/logo.png">
          <div class="message">
            <div>お問い合わせ先</div>
            <div>gacha24@iranoan.com</div>
          </div>
        </div>
      </div>
      <div class="toiawase">
        <div>お問い合わせ先</div>
        <div>gacha24@iranoan.com</div>
      </div> -->
    </div>
  </BaseTemplate>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import TopIconArea from '@/components/molecules/TopIconArea.vue';
// import ShadowButton from '@/components/molecules/ShadowButton.vue';
// import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import RoundButton from '@/components/atoms/RoundButton.vue';

export default {
  name: 'Top',

  components: {
    BaseTemplate,
    ProductBanner,
    TopIconArea,
    // ShadowButton,
    // BlackGradationButton,
    RoundButton,
  },

  data: () => ({
    productList: [],
    showScreen: 1,
  }),
  mixins: [t],

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      packList: 'pack/packList',
      cardTypeList: 'cardType/cardTypeList',
    }),
  },

  watch: {
    packList(newList) {
      for (let i = 0; i < newList.list.length; i += 1) {
        const idx = 0;
        if (!this.productList[idx]) {
          this.productList[idx] = [];
        }
        this.productList[idx].push(newList.list[i]);
      }
    },
  },

  created() {
    this.$store.dispatch('pack/setPackList');
    this.$store.dispatch('cardType/setCardTypeList');
  },

  methods: {
    goToProductDetail(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
    },
    goToLogin() {
      this.$router.push({ path: '/login' });
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToTermsOfService() {
      this.$router.push('/terms-of-service');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    moveList(index) {
      this.$router.push({ path: '/pack-list', query: { index } });
    },
    showTokkyo() {
      window.open('https://iranoan.site/25/');
    },
    goMyPage() {
      if (this.currentUser.is_login === '1') {
        this.$router.push('/my-page');
      } else {
        this.$router.push('/login');
      }
    },
    handleShowScreen(screen) {
      this.showScreen = screen;
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin: 20px 0 20px 0;
  padding: 10px 0;
  color: $white;
  background-color: $yellow;
  text-align: center;
}

.top_message {
  font-size: 18px;
  text-align: center;

  a {
    color: $black !important;
  }
}

._pack_list {
  margin: 0 auto 50px auto;
  max-width: 1220px;

  .banner_list {
    position: relative;

    ._title {
      color: $white;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }

    .list_button {
      border-radius: 5px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
.how_to_play {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 50px 140px;
  border-radius: 30px;
  .how_to_play_title {
    text-align: center;
    margin-bottom: 20px;
    img {
      width: 250px;
    }
  }
  .how_to_play_content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    img {
      width: 30%;
      height: 30%;
    }
    img:nth-child(4),
    img:nth-child(5),
    img:nth-child(6) {
      margin-top: 40px;
    }
  }
}

.top {
  width: 100%;
  max-width: 1800px;
  min-height: 100%;
  margin: 0 auto;

  .sub_title {
    margin-top: 30px;
    background-color: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    padding: 6px 0;
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;

    span {
      margin-right: 10px;
      font-weight: bold;
    }

    div {
      margin-left: 10px;
      background-color: #fff;
      color: $mainColor;
      font-weight: bold;
      border-radius: 100px;
      padding: 10px;
      transition: .4s;
      text-align: center;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        opacity: 0.6;
      }
    }
  }

  .product-list {
    display: flex;
    padding-bottom: 10px;
    flex-wrap: wrap;
  }

  .banner {
    margin-bottom: 20px;
  }

  .double-flex {
    display: flex;
  }

  .shadow-button {
    min-width: 200px;
    max-width: 48%;
    width: 100%;
    height: 40px;
    margin: 20px auto 0;
  }

  .toiawase {
    text-align: center;
    color: $deepGray;
    margin-top: 20px;
  }

  .pc {
    display: block;
  }

  .sp {
    display: none;
  }
}

.message_base {
  margin-bottom: 0;
  margin-top: -80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 28px;
  align-items: center;

  .link {
    color: #285ABE;
    cursor: pointer;
    transition: 0.4s;
    font-size: 34px;

    &:hover {
      opacity: 0.4;
    }
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #707070;
  width: 100%;

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 62px;
    }

    .message {
      font-size: 12px;
      margin-left: 15px;
      color: $white;
    }
  }
}
.screen_switching {
  display: flex;
  justify-content: center;
  margin: 20px 0;
  .detail_button {
    background-color: $headerfoterColor;
    width: 450px;
    height: 66px;
    border-radius: 40px
  }
  .detail_button.active {
    background-color: #88C5E5;
  }
  .detail_button:nth-child(2) {
    margin-left: 20px;
  }
}

@media screen and (max-width: $tabletWidth) {
  ._pack_list {
    margin: 0 10px 20px 10px;

    .banner_list {
      ._title {
        color: $white;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .how_to_play {
    padding: 20px;
    .how_to_play_title {
      img {
        width: 180px;
      }
    }
    .how_to_play_content {
      flex-direction: column;
      text-align: center;
      img {
        margin: 60px auto 0;
        width: 80%;
        height: 80%;
      }
      // 1つめだけmargin-top はつけない nth-child
      img:nth-child(1) {
        margin-top: 0;
      }
    }
  }

  .top {
    .pc {
      display: none;
    }

    .sp {
      display: block;
    }

    .top_message {
      font-size: 16px;
    }

    .sub_title {
      padding: 5px 0;
      margin-top: 10px;
      width: 90vw;

      span {
        font-size: 14px;
        margin-right: 4px;
      }

      div {
        font-size: 10px;
        width: 50px;
        padding: 10px 5px;
        border-radius: 100px;
        text-align: center;
        color: $mainColor;

        &:hover {
          opacity: 1;
        }
      }
    }

    .banner_base {
      margin: 10px 2px 5px 2px;
      width: 48.6%;
      min-width: 30vw;
    }
  }
  .screen_switching {
    flex-direction: column;
    .detail_button {
      margin: auto;
      width: 343px;
      height: 50px;
      font-size: 12px;
    }
    .detail_button:nth-child(2) {
      margin-top: 10px;
    }
  }
}
</style>
